export const SLOT_LIST_SOURCE = 'slots';
